// extracted by mini-css-extract-plugin
export default {"link":"HeadPage_link__J9uok","lastLink":"HeadPage_lastLink__cJlvh"};